module.exports = __webpack_public_path__ + "static_assets/media/bell2.74b23ef.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/bell2.mp3
// module id = HTyA
// module chunks = 40